import CachedIcon from '@mui/icons-material/Cached'
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload'
import { Box, Button, Stack, TextField, Typography } from '@mui/material'
import { useState } from 'react'
import axiosClient from 'utils/axiosClient'
import { convertBase64AndResize } from 'utils/converts'
import DialogConfirm from './Dialog'

interface Props {
  open: boolean
  handleClose: () => void
}

export default function UploadImage({ open, handleClose }: Props) {
  const [image, setImage] = useState<HTMLCanvasElement>()
  const [width, setWidth] = useState<number>()
  const [file, setFile] = useState<File>()
  const [filename, setFilename] = useState('')
  const onSubmit = async () => {
    if (!file) return
    try {
      if (!image) {
        throw new Error('image required')
      }
      if (!filename) {
        throw new Error('filename required')
      }
      const formData = new FormData()
      await new Promise((rs) => {
        image.toBlob((blob) => {
          if (blob) {
            let f = new File([blob], filename + '.png', {
              type: blob.type,
            })
            formData.append('img', f)
            rs(1)
          }
        })
      })
      await axiosClient.post('/api/upload', formData)
      handleClose()
    } catch (err) {
      console.log(err)
    }
  }
  return (
    <DialogConfirm
      disabled={!image}
      open={open}
      handleClose={handleClose}
      handleSubmit={onSubmit}
      maxWidth="sm"
      title={'設定'}
      primaryButtonColor="primary"
      primaryButtonText="アップロードする"
    >
      <Stack gap={2} alignItems="center">
        {image && file && (
          <Stack>
            <TextField
              required
              label="ファイル名"
              margin="dense"
              size="small"
              variant="outlined"
              value={filename}
              onChange={(e) => {
                setFilename(e.target.value)
              }}
            />
            <Typography>
              幅: {image.width}px - 高: {image.height}
              px
            </Typography>
            <Box
              component="img"
              width={image.width}
              maxWidth="100%"
              src={image.toDataURL()}
            ></Box>
          </Stack>
        )}
        <Stack
          flexDirection="row"
          justifyContent="center"
          gap={2}
          alignItems="center"
        >
          {file && (
            <Stack
              flexDirection="row"
              justifyContent="center"
              alignItems="center"
              gap={1}
              border="1px solid #eee"
              p={2}
            >
              <Typography>幅サイズ</Typography>
              <TextField
                required
                label=""
                margin="dense"
                sx={{
                  width: 100,
                }}
                size="small"
                variant="outlined"
                type="number"
                value={String(width)}
                onChange={(e) => {
                  setWidth(Number(e.target.value) || undefined)
                }}
              />
              <Button
                variant="contained"
                size="small"
                component="label"
                color="primary"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
                onClick={async () => {
                  if (file) {
                    const canvas = await convertBase64AndResize(file, width)
                    setImage(canvas)
                  }
                }}
              >
                <CachedIcon />
                <Typography variant="caption" ml={0.4} mt={0.4}>
                  再実行
                </Typography>
              </Button>
            </Stack>
          )}
          <Button
            variant="outlined"
            size="small"
            component="label"
            color="info"
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              ml: file ? 10 : 0,
            }}
          >
            <DriveFolderUploadIcon />
            <Typography variant="caption" ml={0.4} mt={0.4}>
              {image ? '再選択' : '背景選択'}
            </Typography>
            <input
              hidden
              accept="image/*"
              type="file"
              onChange={async (e) => {
                if (e.target.files) {
                  const file = e.target.files[0]
                  if (!file) return
                  setFile(file)
                  const n = file.name.split('.')
                  n.pop()
                  const canvas = await convertBase64AndResize(file, width)
                  setImage(canvas)
                  setFilename(n.join('.'))
                  setWidth(canvas.width)
                }
              }}
            />
          </Button>
        </Stack>
      </Stack>
    </DialogConfirm>
  )
}
